import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { ORGANIZATION_READ } from '../types/organization.js';
export const organizationReadDescriptor = {
    name: ORGANIZATION_READ,
    label: 'Organization',
    domain: 'vectorhub',
    collectionPath: 'org',
    version: 1,
    description: 'Minimal org read model. VH reads products.vectorhub for licensing; never writes the org doc.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            maxLength: 128,
        },
        {
            name: 'name',
            label: 'Name',
            type: 'string',
            required: false,
            maxLength: 256,
            description: 'Human-readable org name, owned by SysColect.',
        },
        {
            name: 'abbreviation',
            label: 'Abbreviation',
            type: 'string',
            required: false,
            maxLength: 16,
            description: 'Short org abbreviation, owned by SysColect.',
        },
        {
            name: 'products',
            label: 'Products',
            type: 'object',
            required: false,
            description: 'Generic add-on product map. VH reads products.vectorhub and products.ai.contracted; never writes.',
        },
    ],
};
//# sourceMappingURL=organization.descriptor.js.map